/**
 * Maps frontend userInfo.role to backend push-token API prefix.
 * law_body is skipped — backend DeviceToken enum has no law_body role and
 * admin mapping is not confirmed for that account type.
 */

const ADMIN_API_ROLES = new Set(["admin", "super_admin", "manager"]);

export function resolveFcmApiPrefix(userInfo) {
  const role = userInfo && userInfo.role;
  if (!role) {
    return null;
  }
  if (role === "user") {
    return "user";
  }
  if (role === "seller") {
    return "seller";
  }
  if (ADMIN_API_ROLES.has(role)) {
    return "admin";
  }
  if (role === "law_body") {
    return null;
  }
  return null;
}

export function canRegisterFcmForUser(userInfo) {
  return resolveFcmApiPrefix(userInfo) !== null;
}
